import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import Government from "@/pages/Government";
import Certifications from "@/pages/Certifications";
import Safety from "@/pages/Safety";
import CaseStudies from "@/pages/CaseStudies";
import Quote from "@/pages/Quote";
import Contact from "@/pages/Contact";
import Careers from "@/pages/Careers";
import NotFound from "@/pages/NotFound";

function ScrollTop() {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollTop />
        <Header />
        <main className="pt-24 md:pt-28 min-h-screen bg-[var(--es-bg)]">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/government" element={<Government />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/safety" element={<Safety />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/quote" element={<Quote />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
